<template>
    <sg-email-confirm ref="confirm" :email="email" @resend="onResend" @confirmed="onConfirmed" />
</template>

<script>
    import emailMixin from './emailMixin'
    import SgEmailConfirm from './SgEmailConfirm'

    export default {

        props: {
            email: {
                type: String,
                required: true
            }
        },

        mixins: [emailMixin],


        components: {
            SgEmailConfirm
        },

        computed: {
            currentEmail() {
                return this.$store.state.settings.userInfo.contacts.email
            }
        },

        methods: {
            onResend() {
                this.changeEmail(this.email, null, true, () => {
                    this.$eventBus.$emit('snackbar:open', {
                        message: "Код был повторно оправлен",
                        props: {
                            bottom: true
                        }
                    })
                    this.$refs.confirm.focus()
                })
            },

            onConfirmed() {
                this.$eventBus.$emit('modal:close')

                this.$router.go(-2)

                this.$eventBus.$emit('snackbar:open', {
                    message: this.currentEmail ? 'Адрес электронной почты изменен' :
                        'Адрес электронной почты привязан'
                })
            }
        }
    }
</script>

<style>

</style>